import req from '@/services/request';

export const getModulesAsAdmin = course => req.get('school/modules/admin', {
  params: { course },
});

export const getModulesAsUser = courseId => req.get(`school/modules/${courseId}/public`);
export const getModulesByCourse = courseId => req.get(`school/modules/course/${courseId}`);

export const reorder = data => req.post('school/courses/reorder', data);

export const createClass = data => req.post('school/classes', data);

export const retrieveClass = id => req.get(`school/classes/${id}`);
export const getAllClasses = courseId => req.get(`school/classes/course/${courseId}`);

export const retrieveClassesByModuleId = moduleId => req.get('school/classes', {
  params: { moduleId },
});

export const updateClass = (id, data) => req.put(`school/classes/${id}`, data);

export const deleteClass = id => req.delete(`school/classes/${id}`);

export const createModule = courseId => req.post('school/modules/', { courseId });

export const retrieveModule = id => req.get(`school/modules/${id}`);

export const updateModule = (id, data) => req.put(`school/modules/${id}`, data);

export const deleteModule = id => req.delete(`school/modules/${id}`);

export const getCohortList = () => req.get('school/cohorts');

export const createCohort = () => req.post('school/cohorts');

export const deleteCohort = id => req.delete(`school/cohorts/${id}`);

export const getCohortCSV = date => req.get(`school/cohorts/${date}/csv`);

export const toggleClassCompletionState = classId => req.post(`school/progress/${classId}`);

export const getNextLiveClass = courseId => req.get(`school/classes/${courseId}/next-live`);

export const sendMessageToCohort = (date, formData) => req.post(`school/cohorts/${date}/message`, formData);

export const getCourses = () => req.get('school/courses');

export const getAllLiveCourses = () => req.get('school/courses/live/all');

export const duplicateCourse = id => req.post(`school/courses/${id}/duplicate`);

export const deleteCourse = id => req.delete(`school/courses/${id}`);

export const createCourse = () => req.post('school/courses');

export const setLiveCourse = id => req.put('school/courses/live', { id });

export const getLiveCourse = () => req.get('school/courses/live');

export const retrieveCourse = id => req.get(`school/courses/${id}`);

export const updateCourse = data => req.put('school/courses', data);

export const findStudentsByCourse = (courseId = null) => req.get('school/students', {
  params: {
    course: courseId,
  },
});

export const findUserAsStudent = () => req.get('school/students/current');

export const createNote = data => req.post('school/notes', data);

export const retrieveNote = id => req.get(`school/notes/${id}`);

export const updateNote = data => req.put('school/notes/', data);

export const retrieveNoteList = pagination => req.get('school/notes', { params: pagination });
export const getAllNotesByCourse = (courseId, pagination) => req.get('school/notes/course', { params: { courseId, ...pagination } });

export const deleteNote = id => req.delete(`school/notes/${id}`);

export const addEmailToWaitlist = data => req.post('school/waitlist', data);

export const getModuleProgress = courseId => req.get(`school/progress/${courseId}/modules`);

export const getOverallProgress = courseId => req.get(`school/progress/${courseId}/overall`);

export const getClassmates = () => req.get('school/students/classmates');

export const exportWaitlist = () => req.get('school/waitlist/export');

export const sendWaitlistEmail = () => req.post('school/waitlist/send');

export const getPrice = () => req.get('school/checkout/price');

export const getHomepageCourse = () => req.get('school/courses/homepage');

export const verifyVoucher = voucher => req.get('school/courses/verify-voucher', {
  params: { voucher },
});

export const createPaymentIntent = formData => req.post('school/courses/payment-intent', formData);

export const getPaginatedNoteListByOwner = params => req.get('school/notes/owner', { params });

export const getPaginatedNoteListByCourse = params => req.get('school/notes/admin', { params });
